import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _single, _WorkActivity } from "../../../../../../core/services/dataBean/EntityCatalog";
import useModal, { MODAL_LG, MODAL_md } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { EditorWorkActivity } from "../../../../WorkActivity/EditorWorkActivity";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { SelectWorkActivityStatuses } from "../../../../WorkActivityStatuses/SelectWorkActivityStatuses";
import { SelectWorkActivityPriority } from "../../../../WorkActivityPriority/SelectWorkActivityPriority";
import { SelectWorkActivityType } from "../../../../WorkActivityType/SelectWorkActivityType";
import { SelectWorkActivityTaskType } from "../../../../WorkActivityTaskType/SelectWorkActivityTaskType";
import { useSprintBoardContext } from "../../../../ActivityTaskContext/SprintBoardProvider";
import { SelectWorkActivityGroup } from "../../../../WorkActivityGroup/SelectWorkActivityGroup";
import { SelectWorkActivityGroupUserByIDAccount } from "../../../../WorkActivityGroup/WorkActivityGroupUser/SelectWorkActivityGroupUserByIDAccount";

type WorkActivityBean = {
    IDWorkActivity: number;
    [key: string]: any;
};

type WorkActivity = {
    DataBeanProperties: WorkActivityBean;
    DataBeanName: string;
};

export function BacklogActivities() {
    const { instance, bean, setBean } = useDataBean(_WorkActivity);
    const { paginadorWorks: paginador, backlog, loadBacklog, filterActivities } = useSprintBoardContext();

    const modal = useModal("", MODAL_md);
    const modalAdd = useModal("", MODAL_LG);

    useEffect(() => {
        loadBacklog();
    }, [paginador.page, filterActivities]);

    const create = () => {
        setBean({
            State: 1,
            IDReporter: _single.getAccountID(),
        });
        modalAdd.open("Agregar Tarea");
    }

    const editaItem = (obj: any) => {
        const newObj = { ...obj }
        instance.updateWorkActivity(newObj).then(
            (resp: any) => {
                loadBacklog();
                modal.close();
                modalAdd.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const buildPages = () => {
        const result: number[] = [];
        const maxVisible = 5;

        let start = Math.max(1, paginador.page - 2);
        let end = Math.min(paginador.pages, start + maxVisible - 1);

        if (end - start < maxVisible - 1) {
            start = Math.max(1, end - maxVisible + 1);
        }

        for (let i = start; i <= end; i++) {
            result.push(i);
        }

        return result;
    };

    return (
        <>
            <div>
                {backlog.length === 0 ?
                    <div style={{ padding: 12, opacity: 0.75, borderTop: "1px solid rgba(0,0,0,0.06)" }}>
                        {filterActivities.IDWorkActivityGroup
                            ? "Sin resultados para este grupo"
                            : "Sin actividades"}
                    </div>
                    :
                    <>
                        <div style={{ borderTop: "1px solid rgba(0,0,0,0.06)" }}>
                            {backlog.map((it) => {
                                const item = it.DataBeanProperties;

                                return (
                                    <div
                                        key={item.IDWorkActivity}
                                        onClick={() => console.log(item)}
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "12px",
                                            borderBottom: "1px solid rgba(0,0,0,0.06)",
                                            cursor: "pointer"
                                        }}
                                    >
                                        <div style={{ flex: 1 }}>
                                            <div style={{ display: "flex", gap: 10 }}>
                                                <span style={{ fontFamily: "monospace", fontSize: 12, opacity: 0.7 }}>
                                                    {item.WorkActivityCode}
                                                </span>
                                                <span style={{ fontWeight: 500 }}>
                                                    {item.Name}
                                                </span>
                                            </div>

                                            <div style={{ fontSize: 12, opacity: 0.6, marginTop: 4 }}>
                                                {item.PriorityName} • {item.IDEmployee ? `${item.AccountNit ?? "S/D"} - ${item.AccountFullName ?? ""}` : "Sin asignar"}
                                                {item.DefeatDate ? ` • Fecha de Vencimiento: ${item.DefeatDate.split(" ")[0]}` : " • Sin Fecha de Vencimiento"}
                                            </div>
                                        </div>

                                        <div style={{
                                            fontSize: 12,
                                            fontWeight: 600,
                                            opacity: 0.7
                                        }}>
                                            {item.StatusesName?.toUpperCase()}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>


                        {paginador.pages > 1 && (
                            <div style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 6,
                                padding: "12px 0"
                            }}>

                                <button
                                    onClick={() => {
                                        if (paginador.page > 1) {
                                            paginador.setPage(paginador.page - 1);
                                        }
                                    }}
                                    disabled={paginador.page === 1}
                                    style={{
                                        border: "none",
                                        background: "transparent",
                                        cursor: paginador.page === 1 ? "default" : "pointer",
                                        opacity: paginador.page === 1 ? 0.4 : 0.8,
                                        padding: "4px 8px"
                                    }}
                                >
                                    ◀
                                </button>

                                {buildPages().map(p => (
                                    <button
                                        key={p}
                                        onClick={() => paginador.setPage(p)}
                                        style={{
                                            border: "none",
                                            background: p === paginador.page ? "rgba(0,0,0,0.08)" : "transparent",
                                            cursor: "pointer",
                                            padding: "4px 8px",
                                            borderRadius: 4,
                                            fontWeight: p === paginador.page ? 600 : 400
                                        }}
                                    >
                                        {p}
                                    </button>
                                ))}

                                <button
                                    onClick={() => {
                                        if (paginador.page < paginador.pages) {
                                            paginador.setPage(paginador.page + 1);
                                        }
                                    }}
                                    disabled={paginador.page === paginador.pages}
                                    style={{
                                        border: "none",
                                        background: "transparent",
                                        cursor: paginador.page === paginador.pages ? "default" : "pointer",
                                        opacity: paginador.page === paginador.pages ? 0.4 : 0.8,
                                        padding: "4px 8px"
                                    }}
                                >
                                    ▶
                                </button>

                            </div>
                        )}

                    </>
                }

                <div className="d-flex justify-content-between px-3 py-2">
                    <button onClick={() => { create() }} style={{ border: "none", background: "transparent", cursor: "pointer", fontWeight: 600, opacity: 0.85 }} >
                        + Crear
                    </button>
                </div>

                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }} onSubmitLabel="Seleccionar" >
                    <div className="row">
                        <div className="col-md-12">
                            <EditorWorkActivity idSelector={bean.IDWorkActivity} onChange={(e) => { setBean({ ...e }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Nombre de la Tarea</label>
                            <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, Name: e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Codigo de la Tarea</label>
                            <input type="text" className="form-control" value={bean.WorkActivityCode} onChange={(e) => { setBean({ ...bean, WorkActivityCode: e.target.value }) }} />
                        </div>
                        <div className="col-md-6">
                            <InputDate label="Fecha de Inicio" name="" value={bean.FromDate} setDate={(e) => { setBean({ ...bean, FromDate: e }) }} withTime />
                        </div>
                        <div className="col-md-6">
                            <InputDate label="Fecha de Vencimiento" name="" value={bean.DefeatDate} setDate={(e) => { setBean({ ...bean, DefeatDate: e }) }} withTime />
                        </div>
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-6">
                                    <SelectWorkActivityGroup label="Areas Disponibles" idSelector={bean.IDWorkActivityGroup} onChange={(e) => { setBean({ ...bean, IDWorkActivityGroup: e }) }} />
                                </div>
                                {bean.IDWorkActivityGroup &&
                                    <div className="col-md-6">
                                        <SelectWorkActivityGroupUserByIDAccount label="Responsable" idGroup={bean.IDWorkActivityGroup} idSelector={bean.IDEmployee} onChange={(e) => { setBean({ ...bean, IDEmployee: e }) }} />
                                    </div>
                                }
                            </div>

                        </div>
                        <div className="col-md-6">
                            <label>Estado</label>
                            <SelectWorkActivityStatuses label=" " idSelector={bean.IDWorkActivityStatuses} onChange={(e) => { setBean({ ...bean, IDWorkActivityStatuses: e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Prioridad</label>
                            <SelectWorkActivityPriority label=" " idSelector={bean.IDWorkActivityPriority} onChange={(e) => { setBean({ ...bean, IDWorkActivityPriority: e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Tipo de Tarea</label>
                            <SelectWorkActivityType label=" " idSelector={bean.IDWorkActivityType} onChange={(e) => { setBean({ ...bean, IDWorkActivityType: e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Clasificación</label>
                            <SelectWorkActivityTaskType label=" " idSelector={bean.IDWorkActivityTaskType} onChange={(e) => { setBean({ ...bean, IDWorkActivityTaskType: e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>

        </>
    );
}